import { API_BASE } from '@/config.ts';
import { fetchWithPersistentCacheUnencrypted } from '@/utils/fetch-with-cache.ts';

/**
 * Fetches Steam icon or S3 saved uploaded image from API if present
 * Make sure to pass .exe, NOT game display name
 * @param processName .exe name
 */
export const getGameIconAndNameByProcessName = async (processName: string) => {
  try {
    const response = await fetchWithPersistentCacheUnencrypted(`${API_BASE}/api/games/steam-icon`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ processName: processName }),
    }, 120_000);

    if (!response) {
      throw new Error('Failed to fetch game icon');
    }

    const data = response;
    return {
      appName: data.appName,
      imageUrl: data.imageUrl,
    };
  } catch (error) {
    return null;
  }
};

/**
 * Removes .exe from name
 * @param exeName game.exe
 */
export const formatGameName = (exeName: string): string => {
  if (!exeName) return '';

  const nameWithoutExe = exeName.replace(/\.exe$/i, '');
  const capitalizedName = nameWithoutExe.charAt(0).toUpperCase() + nameWithoutExe.slice(1);

  return capitalizedName.length > 17
    ? capitalizedName.slice(0, 14) + '...'
    : capitalizedName;
};